import React, { useEffect, useState } from 'react';
import InterestsCard from './InterestsCard';

export default function InterestsLists({
  interestsList,
  view,
  setMealTypeList,
  setTopicsList,
  profileView = false
}) {
  return (
    <div className={`grid grid--card ${profileView ? 'grid--left' : 'grid--center'}`}>
      {interestsList.map((interest, index) => (
        <InterestsCard
          key={index}
          interest={interest}
          view={view}
          setMealTypeList={setMealTypeList}
          setTopicsList={setTopicsList}
          profileView={profileView}
        />
      ))}
    </div>
  );
}
